const vuexPlugin = store => {  
  store.subscribe((mutation) => {
    const { channel } = window._sanChatConfig

    // console.log('session vuexplugin', mutation, state, store)
    if (!store._vm) {
      console.warn('chatsession missing _vm')
      return
    }
    if (mutation.type === 'nudging/setNudging') {
      store._vm.$session.set(channel + 'nudging', mutation.payload)
      // commit('nudging/setNudging', mutation.payload)
    }
    if (mutation.type === 'uistate/SET_OPEN') {
      store._vm.$session.set(channel + 'chatOpen', mutation.payload)
    } else if (mutation.type === 'uistate/SET_CONVERSATION_STATE') {
      if (mutation.payload === 'CONVERSATION_RATED') { // delete session if user has finished rating step
        store._vm.$session.clear()
        return
      }
      store._vm.$session.set(channel + 'uiConvState', mutation.payload)
    } else if (mutation.type === 'conversation/SET_USER_PROFILE') {
      store._vm.$session.set(channel + 'userId', mutation.payload.userId)
    } else if (mutation.type === 'conversation/SET_CONVERSATION') {
      if (mutation.payload) {
        store._vm.$session.set(channel + 'convId', mutation.payload.convId)
      } else {
        store._vm.$session.set(channel + 'convId', null)
        store._vm.$session.set(channel + 'nudging', false)
        // commit('nudging/setNudging', false)
      }
    } else if (mutation.type === 'conversation/ADD_MESSAGE') {
      if ((mutation.payload.msgType === 'CHAT') && mutation.payload.screenName) {
        store._vm.$session.set(channel + 'lastScreenName', mutation.payload.screenName)
        store._vm.$session.set(channel + 'lastSenderId', mutation.payload.senderId)
      }
    } else if (mutation.type === 'uistate/SET_TRANSCRIPT_EMAIL') {
      store._vm.$session.set(channel + 'transcriptEmail', mutation.payload)
    } else if (mutation.type === 'uistate/SET_TRANSCRIPT_STATE') {
      store._vm.$session.set(channel + 'transcriptState', mutation.payload)
    }
    // called after every mutation.
    // The mutation comes in the format of `{ type, payload }`.
  })
}

const restoreSession = ($session, $chatApi, { commit, dispatch, state }, channel) => {
  // uistate
  let chatOpen = $session.get(channel + 'chatOpen')
  let transcriptEmail = $session.get(channel + 'transcriptEmail')
  let transcriptState = $session.get(channel + 'transcriptState')
  let nudgingState = $session.get(channel + 'nudging')
  let lastScreenName = $session.get(channel + 'lastScreenName')
  let lastSenderId = $session.get(channel + 'lastSenderId')
  dispatch('uistate/checkAgentAvailable').then(() => {
    let uiConvState = state.uistate.conversationState
    $chatApi.getExistingConversation().then(response => {
      if (response) {
        let userId = response.userId
        let convId = response.convId
        reloadData($chatApi, $session, state, commit, dispatch, userId, convId, uiConvState, nudgingState, transcriptState, transcriptEmail, chatOpen, lastScreenName, lastSenderId)
      }
    })
  })
}

function reloadData ($chatApi, $session, state, commit, dispatch, userId, convId, uiConvState, nudgingState, transcriptState, transcriptEmail, chatOpen, lastScreenName, lastSenderId) {
  if (userId && convId) {
    dispatch('uistate/setRestoringSession', true)
    if (['INIT', 'READY', 'CONVERSATION', 'CONVERSATION_SUSPENDED'].indexOf(uiConvState) > -1) {
      $chatApi.checkSession(userId, convId)
        .then(result => {
          if (!result) {
            $session.clear()
          } else {
            let defered = Promise.resolve(true)
            if (chatOpen) {
              defered = dispatch('uistate/open')
            }
            commit('nudging/setNudging', nudgingState)
            return defered.then(() => dispatch('conversation/init', { session: { userId, convId } }))
          }
        })
        .then(() => {
          if (state.conversation.conversation && state.conversation.conversation.status === 'ENDUSER_SUSPENDED') {
            commit('uistate/SET_CONVERSATION_STATE', 'CONVERSATION_SUSPENDED')
            if (transcriptEmail && transcriptState === 'sent') {
              commit('uistate/SET_TRANSCRIPT_EMAIL', transcriptEmail)
              commit('uistate/SET_TRANSCRIPT_STATE', transcriptState)
            }
          }
          if (state.conversation.conversation && state.conversation.conversation.status === 'ENDUSER_ENDED') {
            commit('uistate/SET_CONVERSATION_STATE', 'CONVERSATION_RATING')
          }
          dispatch('conversation/updateUnreadMessages')
        })
        .finally(() => {
          dispatch('uistate/setRestoringSession', false)
        })
    } else if (['CONVERSATION_ENDED', 'CONVERSATION_RATING'].indexOf(uiConvState) > -1) {
      $chatApi.getUserInfo()
        .then(result => {
          if (result.userId !== userId) {
            $session.clear()
          } else {
            // TODO: this is a hack to be able to show the agent's name. could/should be done cleaner
            let conv = {
              convId: convId,
              status: 'ARCHIVED',
              mine: true,
              userId: userId,
              messages: [ {
                msgType: 'CHAT',
                msgId: -99,
                msgText: '   ',
                screenName: 'Sanitas',
                senderId: -1000
              } ]
            }
            if (lastScreenName && lastSenderId) {
              conv.messages[0].screenName = lastScreenName
              conv.messages[0].senderId = lastSenderId
            }
            if (transcriptEmail && transcriptState === 'sent') {
              commit('uistate/SET_TRANSCRIPT_EMAIL', transcriptEmail)
              commit('uistate/SET_TRANSCRIPT_STATE', transcriptState)
            }
            commit('conversation/SET_CONVERSATION', conv)
            commit('conversation/SET_USER_PROFILE', result)
            commit('uistate/SET_CONVERSATION_STATE', uiConvState)
            commit('uistate/SET_OPEN', true)
            commit('nudging/setNudging', false)
          }
        })
        .finally(() => {
          dispatch('uistate/setRestoringSession', false)
        })
    } else {
      $session.clear()
      dispatch('uistate/setRestoringSession', false)
    }
  } else if (chatOpen) {
    return dispatch('uistate/open')
  }
  commit('nudging/setNudging', nudgingState)
  return Promise.resolve()
}

export default {
  vuexPlugin,
  restoreSession
}
